import { render, staticRenderFns } from "./BaseEmbedRow.vue?vue&type=template&id=207ca2dc&"
import script from "./BaseEmbedRow.vue?vue&type=script&lang=js&"
export * from "./BaseEmbedRow.vue?vue&type=script&lang=js&"
import style0 from "./BaseEmbedRow.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports